module.exports = __webpack_public_path__ + "img/step2.179cbd2d.png";